import axios from 'axios';
const REST_API_URL_PREFIX = '/karrier/api';

export default {
	getJobDetails(jobId) {
		return axios.get(`${REST_API_URL_PREFIX}/jobs/${jobId}`);
	}
};
